<style lang="scss" scoped>
.module4 {
  .slide-12 {
    background-color: white;
    // background-image: url("../../../assets/module4/slide11/background.jpg");
    background-image: url("../../../assets/module4/slide12/right_page_waves.svg"),
      url("../../../assets/module4/slide11/background.jpg");
    background-size: cover;
    background-position: center;
    height: calc(100% - 0px);
  }
}
.heading1 {
  color: #f8dc61;
  font-size: 102px;
  line-height: 100px;
  transform: rotate(-3deg);
  transform-origin: 0% 50%;
}
.left {
  padding-left: 5%;
  padding-right: 4%;
  padding-top: 60px;
}
.right {
  padding-right: 5%;
  padding-left: 4%;
}
p {
  color: white;
  margin-bottom: 36px;
}
h2 {
  font-size: 73px;
  margin-top: 60px;
}
.num {
  color: #c90c0f;
  font-size: 110px;
}
.num-wrap {
  display: flex;
  align-items: center;
  color: white;
  &:nth-of-type(1) {
    transform: translateY(30px);
  }
  &:nth-of-type(2) {
    transform: translateX(150px) translateY(-60px);
  }
  &:nth-of-type(3) {
    transform: translateY(-120px);
  }

  .desc {
    width: 177px;
    font-size: 25px;
    margin-bottom: 100px;
    .bt {
      font-size: 72px;
      line-height: 56px;
      margin-top: 15px;
      display: inline-block;
    }
    .c {
      color: #e73048;
    }
  }
}
.bnum {
  font-size: 380px;
}
</style>

<template>
  <div class="slide-12">
    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 11"
        src="@/assets/module4/slide12/112_characters.png"
        class="chars delay-4"
      />
    </transition>
    <div class="flex">
      <div class="flex-1 left">
        <transition name="fadeUp" appear>
          <div v-show="slideIndex == 11">
            <h1 class="heading1">
              As FAST Hero 123 members,
            </h1>
          </div>
        </transition>
        <transition name="fadeUp" appear>
          <p v-show="slideIndex == 11" class="delay-1">
            it’s very important that you remember what you might see if someone
            is having a&nbsp;stroke.
          </p>
        </transition>
        <transition name="fadeUp" appear>
          <p v-show="slideIndex == 11" class="delay-2">
            Do you know what is an easy way to remember what it looks like when
            the Evil Clot causes a stroke?
          </p>
        </transition>
        <transition name="fadeUp" appear>
          <h2 v-show="slideIndex == 11" class="delay-3">
            Just Remember <span class="num">123</span>
          </h2>
        </transition>
      </div>
      <div class="flex-1 right">
        <transition name="fade" appear>
          <div class="delay-5" v-show="slideIndex == 11">
            <div class="num-wrap kooky">
              <div class="bnum kooky">1</div>
              <div class="desc">
                IF SOMEONE’S <span class="bt">FACE</span> SUDDENLY DROOPS TO
                <span class="c">ONE</span>
                SIDE
              </div>
            </div>
          </div>
        </transition>

        <transition name="fade" appear>
          <div class="num-wrap kooky delay-6" v-show="slideIndex == 11">
            <div class="bnum kooky">1</div>
            <div class="desc">
              IF SOMEONE SUDDENLY LOSES POWER IN <span class="c">ONE</span>
              <span class="bt">ARM</span>
            </div>
          </div>
        </transition>

        <transition name="fade" appear>
          <div class="num-wrap kooky delay-7" v-show="slideIndex == 11">
            <div class="bnum kooky">2</div>
            <div class="desc">
              IF <span class="c">TWO</span> INCOHERENT LIPS SUDDENLY AFFECT
              THEIR
              <span class="bt">SPEECH</span>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
